import React from "react";
import { useField } from "formik";

const TextInput = React.forwardRef<any, any>((props: InputPropsType, ref) => {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;
  return (
    <>
      {" "}
      <div className="flex w-full  ">
        {" "}
        <label
          className={`lg:text-[1.5rem]  lg:w-[29rem] w-[203px] lg:mt-[.4rem] text-[14px] text-[#220859] font-light ${props.labelClassName}`}
        >
          {props.label}
        </label>
        <div className="w-full">
          {" "}
          <div
            style={{ borderColor: !error ? props.color : "" }}
            className={`flex items-center  w-full border-b-[0.18rem] border-[#52A8F2]  ${error && "border-rose-500"
              }`}
          >
            {" "}
            <input
              ref={ref}
              {...field}
              className="coustom-input"
              type="text"
              placeholder="Jane Doe"
              aria-label="Full name"
              {...props}
            ></input>
          </div>
          <div className="text-rose-500 text-[12px] h-10 mt-1  lg:text-[1.25rem]">
            {error ? meta.error : ""}
          </div>
        </div>
      </div>
    </>
  );
});
export default TextInput;

type InputPropsType = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  name: string;
  labelClassName?: string;
  color?: string;
};
TextInput.displayName = "TextInput";
